import Event from '../Event';
import Notification from '../Notification';

export default class NotificationProduced extends Event {
    public static type = 'NotificationProduced';

    constructor(public readonly notification: Notification) {
        super(NotificationProduced.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/core/events/NotificationProduced.ts